import Breadcrumbs from '@Components/Breadcrumbs';
import Heading from '@Components/Heading';
import { FlowsList } from '@Components/Flows/FlowsList';

export default function FlowsListView() {
  return (
    <div>
      <Breadcrumbs
        navList={[
          { name: 'Flows', href: '/flows' },
          { name: 'List', href: '/flows' },
        ]}
      />
      <div className="mt-8 mb-6">
        <Heading>Flows</Heading>
      </div>
      <FlowsList />
    </div>
  );
}
